import React from "react";

import { Box, makeStyles, Theme, Tooltip, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

const useStyles = makeStyles((theme: Theme) => {
  const { gray30 } = useNormalizedBrandPaletteValues(theme);

  return {
    arrow: {
      color: theme.palette.common.black,
    },
    tooltip: {
      minWidth: 400,
      backgroundColor: theme.palette.common.black,
      // responsive minWidth on mobile to prevent screen overflow
      [theme.breakpoints.down("sm")]: {
        minWidth: "95vw",
      },
    },
    text: {
      fontSize: `${14 / 16}rem`,
      lineHeight: 1.7,
    },
    icon: {
      color: gray30,
    },
  };
});

interface MopInfoTooltipProps {
  headerText?: string; // Optionally accepts the header text for the tooltip
  bodyText: string; // Accepts the body text for the tooltip
  showTooltip?: boolean; // Optionally accepts a boolean to show/hide the tooltip
}

export const MopInfoTooltip: React.FC<MopInfoTooltipProps> = ({
  headerText,
  bodyText,
  showTooltip = true,
}) => {
  const classes = useStyles();

  return showTooltip ? (
    <Box position="absolute" right={-32} top={16}>
      <Tooltip
        classes={{
          arrow: classes.arrow,
          tooltip: classes.tooltip,
        }}
        title={
          <Box padding={2}>
            {headerText && (
              <Typography
                className={classes.text}
                variant="body2"
                color="inherit"
              >
                <strong>{headerText}</strong>
              </Typography>
            )}
            <Typography
              className={classes.text}
              variant="body2"
              color="inherit"
            >
              {bodyText}
            </Typography>
          </Box>
        }
        arrow
        placement="top"
      >
        <InfoOutlinedIcon className={classes.icon} />
      </Tooltip>
    </Box>
  ) : null;
};
